// src/services/otherService.js
import apiClient from './api';

/**
 * Fetches dashboard statistics.
 * @returns {Promise<object>} Stats object { totalQuotes, pendingQuotes, ... }.
 * @throws {Error} If fetching fails.
 */
const API = "api";
export const getStats = async () => {
    try {
        const response = await apiClient.get(`${API}/stats`);
        return response.data;
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'Failed to fetch dashboard stats.';
        console.error("getStats service error:", message);
        throw new Error(message);
    }
};

/**
 * Fetches notifications for the current user.
 * @returns {Promise<Array<object>>} Array of notification objects.
 * @throws {Error} If fetching fails.
 */
export const getNotifications = async () => {
     try {
        const response = await apiClient.get(`${API}/notifications`);
        return response.data; // Expects an array
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'Failed to fetch notifications.';
        console.error("getNotifications service error:", message);
        throw new Error(message);
    }
};

/**
 * Marks a specific notification as read.
 * @param {string} notificationId - The ID of the notification.
 * @returns {Promise<{success: boolean, id: string}>} Confirmation object.
 * @throws {Error} If marking fails.
 */
export const markNotificationAsRead = async (notificationId) => {
    try {
        const response = await apiClient.patch(`${API}/notifications/${notificationId}/read`);
        return response.data;
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'Failed to mark notification as read.';
        console.error("markNotificationAsRead service error:", message);
        throw new Error(message);
    }
};

/**
 * Marks all accessible notifications as read for the current user.
 * @returns {Promise<{success: boolean, message: string}>} Confirmation object.
 * @throws {Error} If marking fails.
 */
 export const markAllNotificationsAsRead = async () => {
    try {
        const response = await apiClient.patch(`${API}/notifications/read-all`);
        return response.data;
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'Failed to mark all notifications as read.';
        console.error("markAllNotificationsAsRead service error:", message);
        throw new Error(message);
    }
};

// --- Add functions for Messages, Projects here if you implement those backend endpoints ---
/*
export const getMessages = async (params = {}) => { ... };
export const getProjects = async (params = {}) => { ... };
*/